module.exports = __webpack_public_path__ + "static/img/home-btns.248952c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme1/excellentCourse/home-btns.png
// module id = /UrU
// module chunks = 319